import { GET_FINANCING_LEDGER_REPORT } from "../../../Types";

const FinancingLedgerReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_FINANCING_LEDGER_REPORT:
      return action.payload;

    default:
      return state;
  }
};
export default FinancingLedgerReportReducer;
